module.exports = __webpack_public_path__ + "static/media/Home Computer Desk.05ee4a37.jpg";